import React, { useState, useEffect } from "react";

import { GeneralModal, Datepicker } from "components";

import { func_validation } from "functions";
import useMobileLicenseKey from "dataflow/billingPortal/actions/useMobileLicenseKey.actions";


export function useExtendDate({ comId }) {

    const { extendDate } = useMobileLicenseKey();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [trialExpiryDate, settrialExpiryDate] = useState();
    const [licenseKey, setlicenseKey] = useState();

    function updateModalState(value) {
        setIsModalVisible(true)
        setlicenseKey(value?.LicenseKey)
    }

    useEffect(() => {
        if(!isModalVisible) {
            setlicenseKey(undefined)
            settrialExpiryDate(undefined)
        }
    }, [isModalVisible])

    let modalDisplay = (
        <GeneralModal
            modalWapperClassName={"mobile-license-key__extendDateModal"}
            isModalVisible={isModalVisible}

            title={"Extend Date"}
            headerClassName={"mobile-license-key__extendDateModal-header"}
            updateParentState={setIsModalVisible}

            bodyWrapperClassName={"mobile-license-key__extendDateModal-bodyWrapper"}
            contentClassName={"mobile-license-key__extendDateModal-content"}
            content={(
                <Datepicker
                    isInputRequired
                    label={"Trial Expiry Date"}
                    defaultDate={trialExpiryDate}
                    handleOnChange={settrialExpiryDate}
                    isResetRequired={isModalVisible}
                />
            )}

            footerClassName={"mobile-license-key__extendDateModal-footer"}
            confirmButtonText={"Save"}
            footerCancelWrapperClassName={"px-2"}
            footerCancelClassName={"mobile-license-key__extendDateModal-footer__cancel-button"}
            footerConfirmWrapperClassName={"px-2"}
            cancelButtonText={"Cancel"}
            handleOnConfirm={() => {
                if(func_validation.isNotNullUndefined(trialExpiryDate)) {
                    extendDate(comId, licenseKey, trialExpiryDate)
                    setIsModalVisible(false)
                }
            }}
            isCancelButtonVisible isConfirmButtonVisible
        />
    );

    return {
        modalDisplay,
        updateModalState
    }
}